import { memo } from 'react';

import type { TextareaActionField, BaseTypeProps } from 'schemaBuilder/types';

import { TypeWrapper } from '../../ui';

import TextareaBody from './body';

export interface Props extends BaseTypeProps {
  field: TextareaActionField;
}

export const Textarea = ({
  isDragging,
  field,
  dragElement,
  removeElement,
  typeSelectElement,
  fieldKeyElement,
  path,
  theme,
  readonly
}: Props) => {
  return (
    <TypeWrapper
      readonly={readonly}
      schemaField={field.schemaField}
      required={field.required}
      isDragging={isDragging}
      dragElement={dragElement}
      typeSelectElement={typeSelectElement}
      removeElement={removeElement}
      fieldKeyElement={fieldKeyElement}
      path={path}
      theme={theme}
    >
      <TextareaBody
        readonly={readonly}
        schemaField={field.schemaField}
        path={`${path}.schemaField`}
      />
    </TypeWrapper>
  );
};

export default memo(Textarea);
